<template>
    <b-modal id="addressModal" scrollable title="Kundeoplysninger" size="lg">
        <b-card-text>

            <b-row>
                <b-col cols="12" lg="6" class="mb-15">
                    <h4>Faktureringsadresse</h4>
                    <b-row>
                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.billingAddress.company" label="Firma" rules="required"></FormGroup>
                        </b-col>
                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.billingAddress.vatNumber" label="CVR" rules="required"></FormGroup>
                        </b-col>

                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.billingAddress.firstName" label="Fornavn" rules="required"></FormGroup>
                        </b-col>
                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.billingAddress.lastName" label="Efternavn" rules="required"></FormGroup>
                        </b-col>

                        <b-col cols="12">
                            <FormGroup v-model="item.billingAddress.address1" label="Adresse" rules="required"></FormGroup>
                            <FormGroup no-label v-model="item.billingAddress.address2" label="Adresse 2"></FormGroup>
                        </b-col>


                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.billingAddress.zipCode" label="Postnummer" rules="required"></FormGroup>
                        </b-col>

                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.billingAddress.city" label="By" rules="required"></FormGroup>
                        </b-col>


                        <b-col cols="12">
                            <FormGroup v-model="item.billingAddress.country" label="Land" rules="required"></FormGroup>
                        </b-col>

                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.billingAddress.email" label="E-mail" rules="required|email"></FormGroup>
                        </b-col>
                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.billingAddress.phone" label="Telefon" rules="required"></FormGroup>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col cols="12" lg="6" v-if="!item.sameShippingAddress">
                    <h4>Leveringsadresse</h4>
                    <b-row>
                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.shippingAddress.company" label="Firma" rules="required"></FormGroup>
                        </b-col>
                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.shippingAddress.vatNumber" label="CVR" rules="required"></FormGroup>
                        </b-col>

                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.shippingAddress.firstName" label="Fornavn" rules="required"></FormGroup>
                        </b-col>
                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.shippingAddress.lastName" label="Efternavn" rules="required"></FormGroup>
                        </b-col>


                        <b-col cols="12">
                            <FormGroup v-model="item.shippingAddress.address1" label="Adresse" rules="required"></FormGroup>
                            <FormGroup no-label v-model="item.shippingAddress.address2" label="Adresse 2"></FormGroup>
                        </b-col>


                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.shippingAddress.zipCode" label="Postnummer" rules="required"></FormGroup>
                        </b-col>

                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.shippingAddress.city" label="By" rules="required"></FormGroup>
                        </b-col>


                        <b-col cols="12">
                            <FormGroup v-model="item.shippingAddress.country" label="Land" rules="required"></FormGroup>
                        </b-col>

                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.shippingAddress.email" label="E-mail" rules="required|email"></FormGroup>
                        </b-col>
                        <b-col cols="12" md="6">
                            <FormGroup v-model="item.shippingAddress.phone" label="Telefon" rules="required"></FormGroup>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card-text>

        <template #modal-footer="{ ok }">
            <div class="w-100">
                <div class="float-left">
                    <b-form-checkbox v-model="item.sameShippingAddress" switch inline class="mb-5">
                        Samme leveringsadresse
                    </b-form-checkbox>
                </div>

                <b-button variant="primary" class="float-right py-7 px-15" @click="ok">
                    Luk
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    export default {
        components: {},
        data: () => ({

        }),
        computed: {},
        watch: {
            "item.billingAddress": {
                handler() {
                    if (this.item.sameShippingAddress) {
                        this.item.shippingAddress = Object.assign({}, this.item.billingAddress)
                    }
                },
                deep: true
            },
            "item.sameShippingAddress"() {
                if (this.item.sameShippingAddress) {
                    this.item.shippingAddress = Object.assign({}, this.item.billingAddress)
                }
            }
        },
        props: ["item"],
        created() { },
        mounted() { },
        methods: {},
    }
</script>